import { browserDetect } from '@activity/utils'
import Request from '@activity/request'
import { getToken, logout } from './utils'
import { $alert, isObject, toast } from '@/utils'
import { $t } from '@/i18n/LocalContext'
import { NativeRequest } from 'onemt-sdk-native'

let $request: Request | null = null

export const createRequest = (
  userInfo: UserInfo,
  sdkConfig: SdkConfig,
  gamePlayer: GamePlayer
) => {
  const inSDK = window.inSDK

  let requestExternalOptions: {
    serverId?: string
    playerId?: string
    uid?: string
    sessionId?: string
    userid?: string
    lang?: string
    platform?: string
    deviceid?: string
    token?: string
  } = {}

  if (!inSDK) {
    requestExternalOptions.token = getToken()
    requestExternalOptions.playerId = userInfo.playerId
  } else {
    requestExternalOptions.serverId = gamePlayer.serverId
    requestExternalOptions.uid = gamePlayer.playerId
    requestExternalOptions.sessionId = userInfo.sessionId
    requestExternalOptions.userid = userInfo.userId
    requestExternalOptions.lang = userInfo.lang
  }
  requestExternalOptions.platform = sdkConfig.platform
  requestExternalOptions.deviceid = sdkConfig.deviceId

  $request = new Request(
    Object.assign(
      {
        domain: `https://${
          process.env.ENV !== 'production' ? 'testh5api' : 'h5api'
        }.onemt.co`,
        appid: window.appId,
        lang: window.lang,
        serverErrorCatch(data: Rsp<unknown>) {
          const codeList = [
            'NETWORK_ERROR',
            'ERR_LEVEL_NOT_MEET',
            'ERR_INVITATION_CODE_NOT_EXIST',
            'ERR_ALREADY_BOUND_CODE',
            'ERR_ACTIVITY_CONDITIONS_NOT_MEET',
            'ERR_BOUND_LIMIT',
            'ERR_LOTTERY_MAX_LIMIT',
            'TASK_NOT_COMPLETE',
            'ERR_ALREADY_RECEIVED',
            'Event_Not_Open',
            'Event_Has_Ended',
          ] as const
          const rtnmsg = data.rtnmsg as typeof codeList[number]
          const code: typeof rtnmsg = codeList.includes(rtnmsg)
            ? rtnmsg
            : codeList[0]
          if (code === codeList[1]) {
            // $alert($t(code), {
            //   rejectText: $t('退出登录'),
            //   onReject() {
            //     logout()
            //   },
            // })
            toast($t(code), true)
          } else {
            $alert(
              $t(code),
              code === codeList[9]
                ? {
                    resolveClose: true,
                    onResolve() {
                      console.log('closePage')
                      NativeRequest('closePage')
                    },
                  }
                : undefined
            )
          }
        },
        httpErrorCatch(error: any) {
          let response
          if (_isObject(error)) {
            response = error.response
          }
          if (isObject(response) && response != null) {
            const status = response.status
            if (status === 401) {
              if (!inSDK) {
                logout('token过期请重新登录', true, true)
              } else {
                NativeRequest('closePage')
              }
            }
          }

          function _isObject(obj: unknown) {
            return (
              Object.prototype.toString.call(obj) === '[object Error]' ||
              isObject(obj)
            )
          }
        },
      },
      requestExternalOptions
    )
  )
}

export default () => $request
